import { useDispatch } from 'react-redux'
import { openModal, closeModal, closeModalByType } from '../ducks/modalSlice'

export const useModal = () => {
  const dispatch = useDispatch()

  const openModalById = (type: string, props?: Record<string, any>) => {
    const id = `${type}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
    dispatch(openModal({ id, type, props }))
    return id
  }

  const closeModalById = (id: string) => {
    dispatch(closeModal(id))
  }

  const closeModalByTypeName = (type: string) => {
    dispatch(closeModalByType(type))
  }

  return {
    openModal: openModalById,
    closeModal: closeModalById,
    closeModalByType: closeModalByTypeName,
  }
}
